import React from "react";
import { UncontrolledCollapse, Button } from "reactstrap";

const GiveUncontrolledCollapse = ({
  question,
  answer,
  className,
  id,
  style,
  controlledChevron
}) => (
  <div className={className}>
    <Button color="primary" id={id} style={style}>
      {question}
    </Button>
    <UncontrolledCollapse toggler={`#${id}`}>
      <div dangerouslySetInnerHTML={{ __html: answer }} />
    </UncontrolledCollapse>
  </div>
);

export default GiveUncontrolledCollapse;
